module.exports = __webpack_public_path__ + "img/douyin.9bdfb0d9.png";